import BleedWrapper from "theme/components/wrappers/BleedWrapper";
import Div from "theme/layouts/Div";
import FlexibleBlock from "theme/libs/wordpress/content/cmsBlocks/FlexibleBlock";
// import HeroWrapper from "theme/components/wrappers/HeroWrapper";
// import ModuleAspectWrapperLarge from "theme/components/wrappers/ModuleAspectWrapperLarge";
import PropTypes from "prop-types";
import React from "react";

const FlexibleModule = ({ isHero, content, ...rest }) => {
    const textColor = content["text_color"] ?? null;

    if (isHero) {
        return (
            <BleedWrapper as="section" height="85vh" mb={["64px", null, null, null, "104px"]}>
                <FlexibleBlock
                    isHero
                    numberOfColumns={1}
                    content={content.data}
                    // useGridWrapper
                    {...rest}
                />
            </BleedWrapper>
        );
    }

    return (
        <Div
            as="section"
            display="grid"
            aspectRatio={[4 / 6, null, null, null, 16 / 9]}
            maxHeight="100vh"
            width="100%"
            my={["64px", null, null, null, "104px"]}
        >
            <FlexibleBlock
                content={content.data}
                numberOfColumns={1}
                // useGridWrapper
                {...rest}
            />
        </Div>
    );
};

FlexibleModule.propTypes = {
    breadcrumbs: PropTypes.arrayOf(PropTypes.object),
    content: PropTypes.object.isRequired,
    isHero: PropTypes.bool,
};

FlexibleModule.defaultProps = {
    breadcrumbs: null,
    isHero: false,
};

export default FlexibleModule;
